export const GROWTHBOOK_API_HOST = process.env.REACT_APP_GROWTHBOOK_API_HOST ?? '';
export const GROWTHBOOK_CLIENT_KEY = process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY ?? '';